/* Product descriptions follow the selected material, including unavailable combinations. */
if (!customElements.get('suri-material-description')) {
  customElements.define('suri-material-description', class extends HTMLElement {
    connectedCallback() {
      this.onSelectionChange = (event) => {
        const picker = event.target.closest?.('variant-radios, variant-selects');
        if (!picker || !this.productRoot()?.contains(picker)) return;
        this.update(picker);
      };
      document.addEventListener('change', this.onSelectionChange);
      // Defer until the entire section is parsed, including descriptions above the picker.
      this.initialize = () => this.update(this.productRoot()?.querySelector('variant-radios, variant-selects'));
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', this.initialize, { once: true });
      } else {
        this.initialize();
      }
    }

    disconnectedCallback() {
      document.removeEventListener('change', this.onSelectionChange);
      document.removeEventListener('DOMContentLoaded', this.initialize);
    }

    productRoot() {
      return this.closest('[id^="MainProduct-"], [id^="FeaturedProduct-"], .shopify-section, quick-add-modal');
    }

    update(picker) {
      if (!picker) return;
      const values = picker.tagName === 'VARIANT-RADIOS'
        ? Array.from(picker.querySelectorAll('fieldset'), (field) => field.querySelector('input:checked')?.value || '')
        : Array.from(picker.querySelectorAll('select'), (select) => select.value);
      const material = (values[Number(this.dataset.materialIndex)] || '').toLowerCase();
      const color = (values[Number(this.dataset.colorIndex)] || '').toLowerCase();
      let finish = this.dataset.defaultFinish;
      if (color) {
        finish = color.includes('rose') ? 'rose' : color.includes('white') ? 'white' : color.includes('silver') ? 'silver' : 'gold';
      }
      let key = 'default';
      if (!color && /10k|14k/.test(material)) finish = 'gold';
      if (material.includes('10k') || color.includes('10k')) key = `10k-${finish === 'silver' ? 'white' : finish}`;
      else if (material.includes('14k') || color.includes('14k')) key = `14k-${finish === 'silver' ? 'white' : finish}`;
      else if (!material || material.includes('sterling') || material.includes('vermeil')) {
        key = finish === 'silver' || finish === 'white' ? 'silver' : `vermeil-${finish}`;
      }
      if (key === this.dataset.activeMaterial) return;
      const source = this.querySelector(`template[data-material-description="${key}"]`);
      const content = this.querySelector('[data-material-description-content]');
      if (!source || !content) return;
      content.replaceChildren(source.content.cloneNode(true));
      this.dataset.activeMaterial = key;
    }
  });
}
